import { render, staticRenderFns } from "./FBOInfo.vue?vue&type=template&id=5447f2c8"
import script from "./FBOInfo.vue?vue&type=script&lang=js"
export * from "./FBOInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports